module.exports = __webpack_public_path__ + "static/media/Screenshot_5-thumb.a05e3984.png";